<template>
  <div id="container">
    <div id="main">
      <header class="home-header">
        <nav-bar/>
      </header>
      <div class="intro">
        <h3 style="font-weight: bold; font-size: 30px;">Selected Publications:</h3>
        <span style="font-size: 23px; padding-bottom: 15px;">Publication by topic is available
      <router-link style="color: #3895bf" to="/publication/topic">here</router-link>
      and Publication by date is available
      <router-link style="color: #3895bf" to="/publication/date">here</router-link>.</span>
      </div>
      <div class="tabs">
        <el-tabs type="border-card" @tab-click="handleClick" v-model="activeName">

          <el-tab-pane label="All" name="All">
            <van-list v-if="activeName === 'All'">
              <van-cell v-for="(paper, index) in paperList" :key="paper" style="font-size: 18px">
                <strong>{{ index + 1 }}.</strong><strong style="color: red">
                [{{ paper.publicationInShort }}]</strong> <strong>{{
                  paper.title
                }}</strong>
<!--                <a :href="paper.pdf_url" style="color: #3895bf"> [PDF]</a>-->
                <br>
                <div
                  :style="[{fontSize:(String(paper.author).length + String(paper.publication).length + String(paper.year).length + String(paper.note).length < 120 ?'18px':'18px')}]">
                  &#12288;&#12288;{{ paper.author }}
                </div>
                <div style="font-size: 18px">
                  &#12288;&#12288;{{ paper.publication }},
                  {{ paper.year }}.
                  <strong v-if="paper.note != null" style="color: red">({{ paper.note }}).</strong></div>
              </van-cell>
            </van-list>
          </el-tab-pane>

          <el-tab-pane v-for="topic in topicList" :label="topic" v-bind:key="topic" :name="topic">
            <van-list v-if="activeName === topic">
              <van-cell v-for="(paper,index) in paperList" :key="paper" style="font-size: 18px">
                <strong>{{ index + 1 }}.</strong><strong style="color: red">
                [{{ paper.publicationInShort }}]</strong> <strong>{{
                  paper.title
                }}</strong>
<!--                <a :href="paper.pdf_url" style="color: #3895bf"> [PDF]</a>-->
                <br>
                <div
                  :style="[{fontSize:(String(paper.author).length + String(paper.publication).length + String(paper.year).length + String(paper.note).length < 120 ?'18px':'18px')}]">
                  &#12288;&#12288;{{ paper.author }}
                </div>
                <div>
                  &#12288;&#12288;{{ paper.publication }},
                  {{ paper.year }}.
                  <strong v-if="paper.note != null" style="color: red">({{ paper.note }}).</strong></div>
              </van-cell>
            </van-list>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <footer-info/>
  </div>
</template>

<script>
import {Toast} from 'vant'
import navBar from "@/components/NavBar";
import footerInfo from "@/components/FooterInfo";
import {getAllPapers} from '@/service/publication'

export default {
  name: "publicationTopic",
  components: {
    navBar,
    footerInfo,
  },
  data() {
    return {
      activeName: 'All',
      paperList: [],
      source: [],
      topicList: [],
    }
  },
  mounted() {
    this.init()
    this.getUrlTabName()
  },

  methods: {
    async init() {
      Toast.loading({message: '加载中...', forbidClick: true});
      const {data: list} = await getAllPapers()
      let temp = list.publication_list
      console.log(temp)
      temp.sort();
      temp = this.extractPublication(temp)
      this.source = temp;
      this.paperList = temp
      console.log(this.paperList)
      this.yearList = this.getYearList(temp);
      this.topicList = this.getTopicList(temp);
      Toast.clear()

    },
    getUrlTabName() {
      this.activeName = this.$route.query.tabName || 'All'
    },
    getTopicList(src) {
      let topics = new Set();
      for (let i = 0; i < src.length; i++) {
        let topic = src[i]['topic'];
        topics.add(topic);
      }
      return Array.from(topics)
    },
    filterPaper(topic) {
      let temp = [];
      for (let i = 0; i < this.source.length; i++) {
        if (this.source[i].topic === topic) {
          temp.push(this.source[i])
        }
      }
      this.paperList = temp
    },
    handleClick(tab) {
      let topic = tab.label
      if (topic === 'All') {
        this.paperList = this.source;
        return
      }
      this.filterPaper(topic)
      this.activeName = tab.label
    },
    getYearList(src) {
      let years = new Set();
      for (let i = 0; i < src.length; i++) {
        let year = src[i]["year"];
        years.add(year);
        this.source[i]['year'] = year
      }
      return Array.from(years)
    },
    extractPublication(paperList) {
      let temp = paperList
      const regex1 = /\((.+)\)/g;   // () 小括号
      for (let i = 0; i < paperList.length; i++) {
        let shortened = paperList[i]["publication"].match(regex1)
        if (shortened != null) {
          shortened = shortened[0]
          shortened = shortened.substring(1, shortened.length - 1)
        } else {
          let commaIndex = paperList[i]["publication"].indexOf(',');
          if (commaIndex !== -1) {
            // 如果找到逗号，提取直到第一个逗号的子字符串
            shortened = paperList[i]["publication"].substring(0, commaIndex);
          } else {
            // 如果没有找到逗号，提取整个字符串
            shortened = paperList[i]["publication"];
          }
        }
        temp[i]['publicationInShort'] = shortened
      }
      return temp
    }
  }
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';

#container {
  position: relative;
}

#main {
  padding-bottom: 150px;
}

.home-header {
  position: fixed;
  left: 0;
  top: 0;
  .wh(100%, 40px);
  .fj();
  line-height: 40px;
  .boxSizing();
  font-size: 12px;
  color: #fff;
  z-index: 10000;
  box-shadow: 0 0 4px 0 @theme-color;

}

.intro {
  .fj(flex-start);
  width: 72%;
  padding-left: 15%;
  font-size: 22px;
  padding-top: 40px;
  padding-bottom: 25px;
  color: #4d5156;
  flex-direction: column;
  text-align: left;
}

.tabs {
  .fj(flex-start);
  width: 86%;
  margin-left: 7%;
  margin-bottom: 30px;

  color: #4d5156;
  background-color: #fefefe;

  flex-direction: column;
  text-align: left;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.text_set {
  font-size: 20px;
}
</style>
